import { gql } from '@/__generated__';

const GET_DEVICE_VPN_CERTIFICATE_URL = gql(`
  query DeviceConfiguration_GetDeviceVpnCertificateUrl($deviceId: ID!) {
    deviceVpnCertificateUrl(deviceId: $deviceId)
  }
`);

export default GET_DEVICE_VPN_CERTIFICATE_URL;
